import { AppEnv, FontStyle } from 'coreOld/enums';
import { APP_ENV, DOMAIN_URL } from 'global';

import { formatString } from './strings';

const IS_SELECTED = 1;

export const getColorsTheme = (fields, wordToReplace: string) => {
  const theme = fields?.reduce((theme, field) => {
    return { ...theme, [formatString(field.name, wordToReplace)]: field.value };
  }, {});

  return theme;
};

export const getFontsTheme = (fields, wordToReplace: string) => {
  const theme = fields?.reduce((theme, field) => {
    return {
      ...theme,
      [formatString(field.name, wordToReplace)]: {
        fontWeight: Number(field.bold) === IS_SELECTED && FontStyle.BOLD,
        fontStyle: Number(field.italic) === IS_SELECTED && FontStyle.ITALIC,
        textDecoration: Number(field.underline) === IS_SELECTED && FontStyle.UNDERLINE,
        fontSize: Number(field.size) ? `${Number(field.size)}px` : 'inherit',
        fontFamily: field.font,
        color: `#${field.color}`,
      },
    };
  }, {});

  return theme;
};

export const getFontSource = (src: string) => {
  if (APP_ENV !== AppEnv.DEVELOPMENT) {
    return src;
  }

  return src.replace('url("/', `url("${DOMAIN_URL}/`);
};
